import * as React from "react";
import * as _ from "lodash";

import { IValueLabel } from "processEditor/model/ITriggerData";
import { connect } from "react-redux";
import { State } from "processEditor/model/State";
import { ParameterEditorValue } from "processEditor/model/ParameterEditorValue";
import { IParameterSchema, IParameters, ParameterType } from "processEditor/model/IProcessData";
import ParameterInput from "../ParameterInput";
import { remoteCallDictionaryName } from "./CallActivityRemoteExecutionEditor";

const CallActivityRemoteExecutionEditorInput = (props: CallActivityRemoteExecutionEditorInputProps) => {
    const defaultValue: ParameterEditorValue = {
        mode: "select",
        value: props.agentGroups[0].value
    }

    const existingCalls: Record<EnvironmentNameKey, ParameterEditorValue | null> = _.get(props.existingParameters, remoteCallDictionaryName);
    const value = _.get(existingCalls, props.environmentName) ?? defaultValue;
    const subParameters: IParameterSchema[] = props.agentGroups.map((agentGroup) => ({
        defaultValue: agentGroup.value,
        inputType: "text",
        isSecret: false,
        name: agentGroup.value,
        label: agentGroup.label,
        parameterType: ParameterType[ParameterType.TextParameter],
        type: "dynamic"
    }))

    return (
        <ParameterInput
            key={props.identifier}
            elementId={props.elementId}
            label={FRENDS.Localizations.SubprocessExecuteOnAgentGroupForEnvironment + " " + props.environmentDisplayName}
            name={props.identifier}
            value={value}
            parameterSchema={{
                defaultValue: props.agentGroups[0].value,
                inputType: "text",
                isSecret: false,
                name: props.identifier,
                parameterType: ParameterType[ParameterType.EnumParameter],
                type: "dynamic",
                subParameters: subParameters
            }}
        />
    )
}

interface CallActivityRemoteExecutionEditorInputOwnProps {
    agentGroups: IValueLabel[];
    elementId?: string;
    identifier: string;
    label: string;
    environmentName: string;
    environmentDisplayName: string;
}

interface CallActivityRemoteExecutionEditorInputStateProps {
    existingParameters?: IParameters;
    disabled?: boolean;
}

type EnvironmentNameKey = string;

type CallActivityRemoteExecutionEditorInputProps = CallActivityRemoteExecutionEditorInputOwnProps & CallActivityRemoteExecutionEditorInputStateProps;

const mapStateToProps = (state: State, ownProps: CallActivityRemoteExecutionEditorInputOwnProps): CallActivityRemoteExecutionEditorInputStateProps => {
    const existing = state.elements[ownProps.elementId as string].parameters;
    return {
        existingParameters: existing,
        disabled: state.uiState.disableEdit
    };
};

export default connect(mapStateToProps)(CallActivityRemoteExecutionEditorInput);
